import { routeConstants } from "src/utils/constants";
import goto from ".";
import { getSessionState, updateSessionState } from "../session";
import { getRouteId } from "src/utils/meristemContext";
import { getURLParams, updateForwardedParams } from "src/utils/urlParams";
import { disableGlobalExit } from "src/utils/globalExit";

declare module "src/pageDefinitions/session" {
  interface BrowserSessionState {
    freemiumOnboardingInitialRoute?: string;
    freemiumOnboardingSourceId?: string;
  }
}

function prepareFreemiumExit() {
  const { freemiumOnboardingInitialRoute } = getSessionState("browser");
  updateForwardedParams({ route: freemiumOnboardingInitialRoute });
  disableGlobalExit();
  return freemiumOnboardingInitialRoute || "app-free-onboarding";
}

function freemiumUpsell(route: routeConstants) {
  const currentRouteId = getRouteId();
  const urlParams = getURLParams();
  const currentRoute = urlParams.route || currentRouteId;

  updateSessionState("browser", {
    freemiumOnboardingInitialRoute: currentRoute,
    freemiumOnboardingSourceId: "app-free-onboarding",
  });

  goto.layer("landing", "app-free-onboarding", false, route);
}

export default {
  freemiumUpsellBranched() {
    freemiumUpsell(routeConstants.freemiumBranched);
  },

  freemiumUpsellWeight(utmSource?: string) {
    if (utmSource) {
      updateForwardedParams({ utm_source: utmSource });
    }
    freemiumUpsell(routeConstants.freemiumWeight);
  },

  freemiumUpsellClinical() {
    freemiumUpsell(routeConstants.freemiumClinical);
  },

  exitToFreemiumOnboarding(entryPoint = "freemiumOnboardingHealthGoals") {
    const route = prepareFreemiumExit();
    goto.mainSurvey(false, route, entryPoint);
  },

  exitToFreeGlp1CompanionOnboarding(entryPoint: string) {
    updateForwardedParams({ utm_source: null });
    const route = prepareFreemiumExit();
    goto.layer(
      "app-free-onboarding-glp1-companion",
      null,
      false,
      route,
      entryPoint
    );
  },

  exitFreemiumUpsell() {
    // Clear the global exit flag from sessionStorage
    disableGlobalExit();
    goto.exitBuyflow("USERPORTAL");
  },
};
